import { atom } from "jotai"

export const pdfGeneratorAtom = atom<(() => string) | null>(null)


